export enum LangIdsInfo {
  en = 'en',
  ua = 'ua',
  pl = 'pl'
}
